(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/components/contextual-anchor.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/components/contextual-anchor.js');
"use strict";


const _React = React,
  useRef = _React.useRef;
setGlobal('svs.ticketsValidate.components.ContextualAnchor', _ref => {
  let children = _ref.children,
    text = _ref.text,
    texts = _ref.texts,
    title = _ref.title;
  const anchorRef = useRef();
  texts = texts !== null && texts !== void 0 ? texts : [text];
  const onClickContextual = e => {
    e === null || e === void 0 || e.preventDefault();
    const dialog = new svs.ui.dialog.Contextual({
      branding: svs.ui.dialog.branding.TUR,
      attachTo: anchorRef.current,
      title,
      message: texts.map(text => ({
        align: svs.ui.dialog.message.align.LEFT,
        type: svs.ui.dialog.message.TEXT,
        text
      }))
    });
    svs.ui.dialog.api.add(dialog);
  };
  return React.createElement("a", {
    onClick: onClickContextual,
    ref: anchorRef
  }, children);
});

 })(window);